<!-- 饼图 -->
<style lang="stylus" scoped>
.pie {
  width: 100%;
  height: 264px;

  .main {
    width: 100%;
    height: 100%;
  }
}
</style>

<template>
  <boxWrap :name="name">
    <div class="pie">
      <div class="main"></div>
    </div>
  </boxWrap>
</template>

<script>
import echarts from 'echarts'
import boxWrap from 'components/dashboard/common/boxWrap';
export default {
  data() {
    return {
      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
      myChart: {},
      name: '电商企业带动贫困户分布'
    }
  },
  components: {
    boxWrap
  },
  methods: {
    init() {
      window.addEventListener('resize', function () {
        this.myChart.resize()
      }.bind(this))
    }
  },
  mounted() {
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(document.querySelector('.pie .main'));
    var data = [{
      value: 19.3,
      name: '田州镇'
    },
    {
      value: 11.3,
      name: '头塘镇'
    },
    {
      value: 7.6,
      name: '洞靖镇'
    },
    {
      value: 7.3,
      name: '百育镇'
    },
    {
      value: 4.2,
      name: '那满镇'
    },
    {
      value: 3.1,
      name: '玉凤镇'
    },
    {
      value: 12.3,
      name: '五村镇'
    },
    {
      value: 17.3,
      name: '坡洪镇'
    },
    {
      value: 15.8,
      name: '那坡镇'
    },
    {
      value: 1.8,
      name: '巴别乡'
    }]
    this.myChart.setOption({
      tooltip: {
        trigger: 'item',
        formatter: "{b} : {c} ({d}%)"
      },

      visualMap: {
        show: false,
        min: 500,
        max: 600,
        inRange: {
          // colorLightness: [0, 1]
        }
      },
      series: [{
        name: '访问来源',
        type: 'pie',
        radius: '50%',
        center: ['50%', '50%'],
        color: ['rgb(131,249,103)', '#FBFE27', '#FE5050', '#1DB7E5', '#00B9FE', '#E7BCF3', '#14D1B0', '#FBFE27', 'rgb(11,228,96)', '#FE5050'], // '#FBFE27','rgb(11,228,96)','#FE5050'
        data: data.sort(function (a, b) {
          return a.value - b.value
        }),
        roseType: 'radius',
        label: {
          normal: {
            formatter: ['{b|{b}}', '{c|{c}%}'].join('  '),
            rich: {
              c: {
                color: 'rgb(241,246,104)',
                fontSize: 14,
                fontWeight: 'bold',
                lineHeight: 10
              },
              b: {
                color: 'rgb(98,137,169)',
                fontSize: 15,
                height: 40
              }
            }
          }
        },
        labelLine: {
          normal: {
            lineStyle: {
              color: 'rgb(98,137,169)'
            },
            smooth: 0.2,
            length: 10,
            length2: 20
          }
        },
        itemStyle: {
          normal: {
            shadowColor: 'rgba(0, 0, 0, 0.8)',
            shadowBlur: 50
          }
        }
      }]
    });
    this.init();
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?684fbf92